import {scrollListener} from "../Listeners/scrollListener";
import {video} from '../Video/videoHandler';

export const toggleFloatingLogo = () => {
	scrollListener((e)=> {
		const target = e.target as Document;
		const floatingLogo = document.getElementById("floating-logo")
		if (video.status === 'ready' && target.documentElement.scrollTop <= 1202) {
			if (floatingLogo) floatingLogo.style.display = "flex";
		} else if (target.documentElement.scrollTop >= 100 && target.documentElement.scrollTop <= 1202 ) {
			if (floatingLogo) floatingLogo.style.display = "flex";
		} else {
			if (floatingLogo) floatingLogo.style.display = "none";
		}
	})
}
